/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-12-19 15:42:08
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2024-02-29 16:17:34
 * @FilePath: \community-backendf:\community-frontend\src\hooks\upload.js
 * @Description: 附件上传
 */

import axios from "axios";
import http from '@/service'
import Piexif from 'piexifjs'
// 国际化
import i18n from '@/lang';
// Element plus 方法类组件
import { toast } from '@/utils/ui'

import { dataURLtoBlob } from '@/utils'
// axios.defaults.timeout = 3000
axios.defaults.timeout = 10000000


// 移除除旋转以外的exif信息
function removeExif (base64Str) {
  
  let exifObj = Piexif.load(base64Str);
  
  // 删除经纬度信息
  delete exifObj.GPS[Piexif.GPSIFD.GPSLatitude];
  delete exifObj.GPS[Piexif.GPSIFD.GPSLongitude];
  let exifBytes = Piexif.dump(exifObj);
  let newImage = Piexif.insert(exifBytes, base64Str);
  return newImage
}
export default async (
  files, 
  business = 'avatar', 
  fileType = 'image', 
  needCreateFile = false,
  activityId,
  chatParams
) => {
  const appid = "overseasOPPOPlus" // 服务id
  let signUrl = `/ocs/upload/${activityId ? 'signup-activity/' : ''}gets` //上传签名接口url
  // 私信预签
  if (business === 'chat') {
    signUrl = '/ocs/upload/chat/gets'
  }
  let source = null
  const handleSignaturParams = (files) => {
    const formateFiles = Array.isArray(files) ? files : [files]
    let arr = [];
    // 图片需要将图片类型名称转为jpeg
    arr = formateFiles.map(item => {
      if (item.file.name.includes("jpg")) {
        item.file.name.replace("jpg", "jpeg");
      }
      const type = item.file.type.split("/")[0]
      return {
        appid,
        scope: 1,
        business,
        filename: item.file.name,
        type: type.includes('image') || type.includes('video') ? item.file.type.split("/")[0] : 'file',
        contentType: item.file.type ? item.file.type : 'file',
        size: item.file.size
      }
    })
    return arr
  }

  const s3Upload = async (file, type, ossToken, index) => {
    // 读取base64
    let base64Str = file
    // 移除exif
    try {
      // base64Str = Piexif.remove(file)
      base64Str = removeExif(file)
    } catch (e) {
      base64Str = file
    }
    // 转换文件流
    let uploadBlob = null
    try {
      uploadBlob = dataURLtoBlob(base64Str)
    } catch {
      uploadBlob = file
    }
    if (files[index]) {
      files[index].status = 'progress'
    } else {
      files.status = 'progress'
    }
    const res = await axios.put(ossToken.presignUrl, uploadBlob, {
      withCredentials: false,
      cache: true,
      headers: {
        'Cache-Control': `max-age=${business === 'chat' ? 1800 : 604800},public,immutable`,
      },
      cancelToken: new axios.CancelToken((c) => {
        source = c;
      }),
      transformRequest: [(data1, headers) => {
        delete headers["X-Requested-With"];
        delete headers["lang"];
        headers['Content-Type'] = type || 'file'
        return data1;
      }],
      onUploadProgress: (progressEvent) => { //获取上传进度的事件
        if (progressEvent.loaded && progressEvent.total) {
          //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
          //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
          let progress = Number(((progressEvent.loaded / progressEvent.total) * 100).toFixed(0))
          if (!isNaN(progress)) {
            if (files[index]) {
              files[index].progress = progress
            } else {
              files.progress = progress
            }
          }
        }
      }
    });
    try {
      if (res.code === 500) {
        throw "Upload Failed!";
      }
      res.data = {};
      res.data.code = res.status;
      if (files[index]) {
        files[index].status = needCreateFile ? 'complete' : 'uploading'
      } else {
        files.status = needCreateFile ? 'complete' : 'uploading'
      }
      return res;
    } catch (e_1) {
      toast({
        message: i18n.global.t('uploadFailed')
      })
      throw "Upload Failed!";
    }
  }

  const createFileId = async ({filename, filesize, attachment, type}) => {
    try {
      let params = [{
        type,
        filename,
        filesize,
        url: attachment,
      }]
      if (business === 'chat') {
        params = {
          ...chatParams,
          attachments: [{
            type,
            filename,
            filesize,
            url: attachment,
          }]
        }
      }
      const res = await http[business === 'chat' ? 'createChatAttachments' : 'createAttachs'](params)
      return res
    } catch (e) {
      toast({
        message: e
      })
    }
  }
  
  const getSignature = async (files) => {
    let signatureData = handleSignaturParams(files) // 签名参数
    let hasWorngFile = false
    let overSize = false
    let isNotMp4 = false
    signatureData.forEach(i => {
      let fileAceptType = i.contentType.split('/')[1]
      if (fileType === 'image' && i.type !== 'image') {
        files[0].status = 'fail'
        hasWorngFile = true
      }
      if (fileType === 'video' && i.type !== 'video') {
        files[0].status = 'fail'
        hasWorngFile = true
      }
    })
    if (hasWorngFile){
      toast({
        message: i18n.global.t('fileValidate', {
          type: fileType === 'image' ? i18n.global.t('image') : i18n.global.t('video')
        }),
      })
      return false
    }
    if (overSize){
      toast({
        message: i18n.global.t('sizeValidate', {
          size: '100MB'
        }),
      })
      return false
    }
    if (isNotMp4){
      toast({
        message: i18n.global.t('videoTypeValidate'),
      })
      return false
    }
    if (activityId) {
      signatureData = {
        id: activityId,
        ocsPresignList: signatureData
      }
    }
    if (business === 'chat') {
      signatureData = {
        ...chatParams,
        ocsPresignList: signatureData
      }
    }
    // 预签名调用
    const signatureRes =  await axios.post(signUrl, signatureData)
    try {
      if (signatureRes.data.code == 200) {
        const { data } = signatureRes.data
        // 预签名统一返回数组
        const fileDataList = await data.reduce(async (prev, next, index) => {
          // 单文件或是多文件
          // 开发环境处理文件定向到私有桶场景，替换域名为本地代理地址
          if (next.echoUrl && next.echoUrl.includes('/ugc/frontend/attachment/view')) {
            if (import.meta.env.VITE_ENV === 'DEV') {
              let url = new URL(next.echoUrl)
              next.echoUrl = `${location.origin}/proxy${url.pathname}${url.search}` 
            }
            next.echoUrl = next.echoUrl ? `${next.echoUrl}${next.echoUrl.includes('?') ? '&' : '?'}appCode=community&t=${Date.now()}` : ''
          }
          if (files[index]) {
            files[index].previewUrl = next.echoUrl || next.cdnUrl
            files[index].id = next.id
            files[index].progress = 0
            files[index].status = 'uploading'
            files[index].type =  files[index].file.type.includes('video') ? 2 : 1
            files[index].path = next.fileName
          } else {
            files.previewUrl = next.echoUrl || next.cdnUrl
            files.id = next.id
            files.progress = 0
            files.status = 'uploading'
            files.type = files.file.type.includes('video') ? 2 : 1
            files.path = next.fileName
          }
          let { content, file, type: fileType, loadingIndex } = Array.isArray(files) ? files[index] : files
          
          let { name: filename, size: filesize, type } = file
          // s3上传
          try {
            const ossRes = await s3Upload(content || file, type, next, index)
            if (files[index]) {
              files[index].status = 'uploading'
            } else {
              files.status = 'uploading'
            }
            if (ossRes.data.code === 200) {
              ossRes.data = Object.assign({...ossRes.data}, {
                url: ossRes.config.url.split("?")[0],
                filename,
                filesize,
                attachment: next.fileName,
                type: fileType
              })
              // 是否需要创建附件id
              if (needCreateFile) {
                // 创建附件id
                let idData = await createFileId(ossRes.data)
                // idData.code = 500
                if (idData.code !== 200) {
                  toast({
                    message: i18n.global.t('uploadFailed'),
                  })
                }
                if (files[index]) {
                  files[index].status = idData.code === 200 ? 'complete' : 'fail'
                  // if (index === 2) {
                  //   files[index].status = 'fail'
                  // }
                } else {
                  files.status = idData.code === 200 ? 'complete' : 'fail'
                }
                // 图片路径添加
                idData.path = next.echoUrl || next.cdnUrl
                idData.loadingIndex = loadingIndex || ''
                return [...(await prev), {...idData}]
              } else {
                if (files[index]) {
                  files[index].status = 'complete'
                } else {
                  files.status = 'complete'
                  // files.status = 'fail'
                }
                // if (index === 1) {
                //   files[index].status = 'fail'
                // }
              }

              // 非帖子无需创建附件id，直接返回s3相关数据
              return [...(await prev), ossRes.data]
            } else {
              files[index].status = 'fail'
              return false
            }
          } catch (e) {
            files[index].status = 'fail'
            return false
          }
        }, [])
        return fileDataList
      } else {
        if (Array.isArray(files)) {
          files.forEach(i => {
            i.status = 'fail'
          })
        } else {
          files.status = 'fail'
        }
        toast({
          message: signatureRes.data.msg || 'Network Error',
        })
        return false
      }
    } catch (e) {
      if (Array.isArray(files)) {
        files.forEach(i => {
          i.status = 'fail'
        })
      } else {
        files.status = 'fail'
      }
      return false
    }
  }
  return (await getSignature(files))
}